import { useEffect, type MutableRefObject } from 'react';
import { logger } from '@fiverr-private/obs';
import { useScrollCallback } from '../../../../../shared/hooks/useScrollCallback/useScrollCallback';
import { toggleCategoriesMenu } from '../../../../../shared/utils/categoriesMenuToggler';
import { HEADER_SELECTOR } from '../../../constants';

export const useCategoriesToggle = (triggerRef: MutableRefObject<HTMLElement | null>) => {
    const callback = () => {
        const header = document.querySelector<HTMLElement>(HEADER_SELECTOR);
        if (!header) {
            logger.error({
                message: 'Header element not found. CategoriesMenu will be always rendered as a safe fallback',
            });
            toggleCategoriesMenu(true);
            return;
        }
        if (!triggerRef.current) {
            logger.error({
                message: 'Scroll trigger element not found. CategoriesMenu will be always rendered as a safe fallback',
            });
            toggleCategoriesMenu(true);
            return;
        }
        const triggerRect = triggerRef.current.getBoundingClientRect();
        const headerRect = header.getBoundingClientRect();
        toggleCategoriesMenu(triggerRect.bottom < headerRect.bottom);
    };
    useScrollCallback(callback);
    useEffect(callback, [triggerRef]);
};
